// src/api/backgroundjobs/backgroundJobApi.ts
import apiHandler from '../core/apiHandler';

const backgroundJobApi = apiHandler('background-jobs');

export default backgroundJobApi;